module.exports = __webpack_public_path__ + "static/img/iconshipin_24_hei.048768b3.png";